import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { showToast } from "services/utils/Status";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { Loader } from "components/Loader";
import { IndividualMemberHeader } from "pages/Administration/AdministrationHeaders";
import { AddEmployee } from "./AddEmployee";
import { MoveEmployee } from "./MoveEmployee";

export const ViewGroupMembers = ({
  viewAssignDetails,
  setRenderComponentName,
  setShowTopBar,
}) => {
  const { domain, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [incentiveDetailsStateData, setIncentiveStateData] = useState([]);
  const [updateData, setUpdateData] = useState(true);
  const [addEmployee, setAddEmployee] = useState(false);
  const [moveEmployee, setMoveEmployee] = useState(false);
  const containerRef = useRef(null);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Work Unit",
    "Assign"
  );

  const {
    result: IncentiveData,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}assignment_details/${viewAssignDetails.id}/employee_details/`
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (updateData && IncentiveData?.length !== 0 && IncentiveData) {
      setIncentiveStateData(IncentiveData);
      setUpdateData(false);
    }
  }, [IncentiveData, updateData]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return (
    <React.Fragment>
      {addEmployee ? (
        <AddEmployee
          viewAssignDetails={viewAssignDetails}
          setAddEmployee={setAddEmployee}
          reCallApi={reCallApi}
          IncentiveData={IncentiveData}
        />
      ) : loading ? (
        <Loader />
      ) : moveEmployee ? (
        <MoveEmployee
          setMoveEmployee={setMoveEmployee}
          viewAssignDetails={viewAssignDetails}
          IncentiveData={IncentiveData}
          reCallApi={reCallApi}
        />
      ) : incentiveDetailsStateData?.length === 0 ? (
        <>
          <Mui.Grid container sx={{ paddingTop: 2 }}>
            <Mui.Grid item xs={0.4}>
              <BackArrow
                actionFunction={() => {
                  setRenderComponentName("ListView");
                  setShowTopBar(true);
                }}
              />
            </Mui.Grid>
            <Mui.Grid item xs={3}>
              <Mui.Typography
                sx={{ fontSize: 24, fontWeight: 700, paddingTop: 1 }}
              >
                {viewAssignDetails?.name}
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6.5}></Mui.Grid>
            <Mui.Grid item xs={1} sx={{ paddingTop: 1 }}>
              <CustomButton
                actionFuntion={() => setAddEmployee(true)}
                actionName="Add Employee"
                typeName="button"
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Alert severity="info" sx={{ width: "100%", margin: 2 }}>
            No data found
          </Mui.Alert>
        </>
      ) : (
        <React.Fragment>
          <Mui.Grid container sx={{ paddingTop: 2 }}>
            <Mui.Grid item xs={0.4}>
              <BackArrow
                actionFunction={() => {
                  setRenderComponentName("ListView");
                  setShowTopBar(true);
                }}
              />
            </Mui.Grid>
            <Mui.Grid item xs={3}>
              <Mui.Typography
                sx={{ fontSize: 24, fontWeight: 700, paddingTop: 1 }}
              >
                {viewAssignDetails?.name}
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6.5}></Mui.Grid>
            <Mui.Grid item xs={1} sx={{ paddingTop: 1 }}>
              <CustomButton
                actionFuntion={() => {
                  if (check_access) {
                    setAddEmployee(true);
                  } else {
                    showToast(
                      "error",
                      `Access denied: You are not authorized to add employee`
                    );
                  }
                }}
                actionName="Add Employee"
                typeName="button"
              />
            </Mui.Grid>
            <Mui.Grid item xs={1.1} sx={{ paddingTop: 1 }}>
              <CustomButton
                actionFuntion={() => {
                  if (check_access) {
                    setMoveEmployee(true);
                  } else {
                    showToast(
                      "error",
                      `Access denied: You are not authorized to move employee`
                    );
                  }
                }}
                actionName="Move Employee"
                typeName="button"
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.TableContainer
              ref={containerRef}
              sx={{ mt: 2, width: "100%", ml: 2, mr: 2, maxHeight: 850 }}
            >
              <Mui.Table>
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow
                    sx={{
                      "& .MuiTableCell-root": {
                        height: "10px",
                        padding: "6px 30px",
                      },
                    }}
                  >
                    {IndividualMemberHeader.map((head) => (
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        {head.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {incentiveDetailsStateData
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((account, index) => (
                      <React.Fragment>
                        <Mui.TableRow
                          sx={{
                            "& .MuiTableCell-root": {
                              height: "10px",
                              padding: "6px 35px",
                            },
                          }}
                        >
                          {IndividualMemberHeader.map((head) => (
                            <Mui.TableCell>
                              {head?.key === "user_name" ? (
                                <Mui.Stack direction="Row">
                                  <Mui.Avatar
                                    sx={{ width: 23, height: 23 }}
                                    alt={account?.user_name
                                      ?.charAt(0)
                                      .toUpperCase()}
                                    src={account?.image_url ?? optionalAvathar}
                                  />
                                  &nbsp;
                                  {account?.user_name}
                                </Mui.Stack>
                              ) : account[head.key] ? (
                                account[head.key]
                              ) : (
                                "N/A"
                              )}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      </React.Fragment>
                    ))}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
          <Mui.Grid
            container
            sx={{
              paddingTop: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              paddingRight: 1,
            }}
          >
            {incentiveDetailsStateData?.length > 25 && (
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={incentiveDetailsStateData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Mui.Grid>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
